import { Axios } from '../axiosInstance';

const axiosInstance = Axios();

const trainProgressManager = {
  getTrainProgress(url: any) {
    return axiosInstance.v2({
      url: url,
      method: 'GET'
    });
  }
};

export default trainProgressManager;
